import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@ui-nuvertos/shared';

@Injectable({
  providedIn: 'root'
})
export class AssetDepreciationService {
  private assetUrl = environment.assetUrl;

  constructor(private http: HttpClient) {}

  /**
   * Generate a depreciation preview for a financial year.
   * Always recalculates fresh. Returns JSON with run data.
   */
  generatePreview(financialYear: string): Observable<any> {
    const url = `${this.assetUrl}/api/v1/asset-depreciation/preview`;
    return this.http.post<any>(url, { financial_year: financialYear }, { withCredentials: true });
  }

  /**
   * Approve and apply a depreciation run. Returns JSON with run data.
   */
  applyDepreciation(runId: string): Observable<any> {
    const url = `${this.assetUrl}/api/v1/asset-depreciation/apply/${runId}`;
    return this.http.post<any>(url, {}, { withCredentials: true });
  }

  /**
   * Download Excel for a depreciation run. Returns blob.
   */
  downloadRunExcel(runId: string): Observable<Blob> {
    const url = `${this.assetUrl}/api/v1/asset-depreciation/runs/${runId}/download`;
    return this.http.get(url, { withCredentials: true, responseType: 'blob' });
  }

  /**
   * List all depreciation runs with pagination.
   */
  getDepreciationRuns(filters?: any): Observable<any> {
    const url = `${this.assetUrl}/api/v1/asset-depreciation/runs`;
    let params = new HttpParams();
    if (filters) {
      if (filters.limit) params = params.set('limit', filters.limit.toString());
      if (filters.offset !== undefined) params = params.set('offset', filters.offset.toString());
    }
    return this.http.get<any>(url, { params, withCredentials: true });
  }

  /**
   * Get a single depreciation run by ID.
   */
  getDepreciationRun(runId: string): Observable<any> {
    const url = `${this.assetUrl}/api/v1/asset-depreciation/runs/${runId}`;
    return this.http.get<any>(url, { withCredentials: true });
  }
}
